import { gtmTrack } from '../services/gtmTrack'
import { segmentTrack } from '../services/segmentTrack'

export function useAnalytics(provider: 'gtm' | 'segment' = 'gtm') {
  let track

  switch (provider) {
    default:
    case 'gtm':
      track = gtmTrack
      break

    case 'segment':
      track = segmentTrack
      break
  }

  return track
}
